import classNames from "classnames";
import AIGenerateButtonStar from "static/images/AIGenerateButtonStar.svg";

export const RadianButton = ({
  onClick,
  children,
  className,
  iconSize = "t-size-4",
  size = "regular",
}: {
  onClick: () => void;
  className?: string;
  children: string;
  iconSize?: string;
  size?: "regular" | "small";
}) => (
  <button
    onClick={onClick}
    className={classNames(
      "t-relative t-border-none t-rounded-lg t-p-[1px] t-bg-[linear-gradient(90deg,_#C5A6E9,_#8A4ED4)] t-inline-flex t-items-center t-cursor-pointer t-mt-1 t-min-w-fit",
      {
        [className as string]: className,
      }
    )}
  >
    <span
      className={classNames(
        "t-bg-white hover:t-bg-surface-grey t-rounded-[7px] t-flex t-items-center t-font-medium t-text-[#2d2d2d]",
        {
          "t-px-2 t-py-1 t-gap-1": children && size !== "small",
          "t-w-[30px] t-h-[30px] t-justify-center":
            !children && size !== "small",
          "t-w-[24px] t-h-[24px] t-justify-center": size === "small",
        }
      )}
    >
      <img
        src={AIGenerateButtonStar}
        alt="AIGenerateButtonStar"
        className={iconSize}
      />
      {children && (
        <span className="t-text-subtext-sm t-text-text-60 t-w-fit">
          {children}
        </span>
      )}
    </span>
  </button>
);
